// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lyIM","top":"styles_top__3OfrP"};